import React, { useRef, useEffect, useState } from "react";
import { Icon, Menu, Dropdown } from "semantic-ui-react";

import "./ContextMenu.css";

const ListingContextMenu = ({
  open,
  event,
  closeContextMenu,
  selectedRows,
  rowsPreselected,
  openContextModal,
  openEditPartNumber,
  openEditInventory,
}) => {
  const contextMenuRef = useRef(null);
  const [inventorySubmenuOpen, setInventorySubmenuOpen] = useState(false);

  useEffect(() => {
    if (!open) return;

    const contextMenu = contextMenuRef.current;
    const y = event.pageY - window.scrollY;
    const x = event.pageX;

    // Style the context menu to appear at the clicked coordinates
    contextMenu.style.top = `${y}px`;
    contextMenu.style.left = `${x}px`;
    contextMenu.style.display = `block`;

    function closeMenu(e) {
      const isClickInsideContextMenu = contextMenu.contains(e.target);

      if (!isClickInsideContextMenu) closeContextMenu();
    }

    window.addEventListener("mousedown", closeMenu);

    return () => {
      window.removeEventListener("mousedown", closeMenu);
    };
  }, [open, event, closeContextMenu]);

  if (!open) return null;

  const handleInventoryItemClick = (action) => {
    openContextModal(action);
    setInventorySubmenuOpen(false);
  };

  // Common styles for menu items
  const menuItemStyle = {
    padding: "10px 15px",
    cursor: "pointer",
  };

  const menuItemHoverHandlers = {
    onMouseEnter: (e) => (e.target.style.backgroundColor = "#dcdcdc"),
    onMouseLeave: (e) => (e.target.style.backgroundColor = "#f8f8f8"),
  };

  return (
    <div
      style={{
        position: "fixed",
        zIndex: 997,
        top: 0,
        left: 0,
      }}
    >
      <div
        style={{
          position: "relative",
          zIndex: 998,
        }}
      >
        <div
          ref={contextMenuRef}
          className="context-menu"
          id="pt-context-menu"
          style={{
            position: "absolute",
            width: "250px",
            zIndex: 999,
            display: "none",
          }}
        >
          <Menu vertical>
            {rowsPreselected && (
              <Menu.Item header>
                {`(${selectedRows.length})`} selected..
              </Menu.Item>
            )}
            <Menu.Item
              onMouseEnter={(e) => (e.target.style.backgroundColor = "#dcdcdc")}
              onMouseLeave={(e) => (e.target.style.backgroundColor = "#f8f8f8")}
              onClick={() => openContextModal("family")}
              className="no-pointer"
            >
              <Icon name="edit outline" />
              Edit Families
            </Menu.Item>

            <Menu.Item
              disabled={selectedRows.length > 1}
              onMouseEnter={(e) => (e.target.style.backgroundColor = "#dcdcdc")}
              onMouseLeave={(e) => (e.target.style.backgroundColor = "#f8f8f8")}
              onClick={openEditPartNumber}
              className="no-pointer"
            >
              <Icon name="configure" />
              Edit Part Number
            </Menu.Item>

            {/* Inventory Dropdown */}
            <Dropdown
              item
              text="Inventory"
              open={inventorySubmenuOpen}
              onMouseEnter={() => setInventorySubmenuOpen(true)}
              onMouseLeave={() => setInventorySubmenuOpen(false)}
              className="no-pointer"
              icon={<Icon name="dropdown" style={{ float: "right" }} />}
            >
              <Dropdown.Menu>
                <Dropdown.Item
                  {...menuItemHoverHandlers}
                  style={menuItemStyle}
                  disabled={selectedRows.length > 1}
                  onClick={() =>
                    handleInventoryItemClick("inventory-combinations")
                  }
                >
                  <Icon name="boxes" />
                  View Sets
                </Dropdown.Item>

                <Dropdown.Item
                  {...menuItemHoverHandlers}
                  style={menuItemStyle}
                  disabled={selectedRows.length > 1}
                  onClick={openEditInventory}
                >
                  <Icon name="clipboard list" />
                  Edit Listing
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Menu>
        </div>
      </div>
    </div>
  );
};

export default ListingContextMenu;
